"use strict";function requestAuthInfo$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.requestAuthInfo$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.auth.requestAuthInfo";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"5.1.19"},_a[ddSdk_1.ENV_ENUM.android]={vs:"5.1.19"},_a)),exports.requestAuthInfo$=requestAuthInfo$,exports.default=requestAuthInfo$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/auth/requestAuthInfo.js
// module id = 909
// module chunks = 106